module.exports = __webpack_public_path__ + "static/rolki-2ce37f230181ce92e06ca80101bc196d.jpg";